import { render, staticRenderFns } from "./page-share-new.vue?vue&type=template&id=da70f884&scoped=true"
import script from "./page-share-new.vue?vue&type=script&lang=ts"
export * from "./page-share-new.vue?vue&type=script&lang=ts"
import style0 from "./page-share-new.vue?vue&type=style&index=0&id=da70f884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da70f884",
  null
  
)

export default component.exports